import { render } from "./ChartOfAccountGrid.vue?vue&type=template&id=8459a12a"
import script from "./ChartOfAccountGrid.vue?vue&type=script&lang=js"
export * from "./ChartOfAccountGrid.vue?vue&type=script&lang=js"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__